/**
 * @summary payment-form-sdo
 * @version 1.0.0
 * @since 1.0.0
 * @author Alex Dinari <alex.dinari@aofl.com>
 */
import {Sdo, storeInstance, state, decorate} from '@aofl/store';

/**
 * @type {String}
 * @private
 */
const PAYMENT_FORM = 'paymentForm';

/**
 * @extends {Sdo}
 */
class PaymentFormSdo extends Sdo {
  /**
   * @static
   * @type {String}
   */
  static namespace = PAYMENT_FORM;

  /**
   * @static
   * @type {String}
   */
  @state()
  cardName = '';

  /**
   * @static
   * @type {String}
   */
  @state()
  cardNumber = '';

  /**
   * @static
   * @type {String}
   */
  @state()
  cardMonth = ('0' + (new Date().getMonth() + 1)).slice(-2);

  /**
   * @static
   * @type {String}
   */
  @state()
  cardYear = String(new Date().getFullYear());

  /**
   * @static
   * @type {String}
   */
  @state()
  cardCvv = '';

  /**
   * @static
   * @type {String}
   */
  @state()
  zipCode = '';

  /**
   * @static
   * @type {String}
   */
  @state()
  phoneNumber = '';

  /**
   * @static
   * @type {Boolean}
   */
  @state()
  monthDropdownActive = false;

  /**
   * @static
   * @type {Boolean}
   */
  @state()
  yearDropdownActive = false;

  /**
   * @readonly
   */
  @decorate(`${PAYMENT_FORM}.cardMonth`, `${PAYMENT_FORM}.cardYear`)
  get expDate() {
    return `${this.cardYear}${this.cardMonth}`;
  }
}

/**
 * @type {PaymentFormSdo}
 * @memberof module:@aoflmkt/payment-form-sdo
 */
const paymentFormSdo = new PaymentFormSdo();
storeInstance.addState(paymentFormSdo);

export {
  paymentFormSdo
};
